import React, { useState } from "react";
import styles from "./InfoButton.module.css";

interface InfoButtonProps {
  tooltip: string; // Текст для всплывающей подсказки
  icon?: React.ReactNode; // Иконка для кнопки (по желанию)
}

export const InfoButton: React.FC<InfoButtonProps> = ({ tooltip, icon }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  // Показываем подсказку при наведении
  const handleMouseEnter = () => {
    setIsTooltipVisible(true);
  };

  // Скрываем подсказку при уходе мыши
  const handleMouseLeave = () => {
    setIsTooltipVisible(false);
  };

  const defaultIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2ZM13.4999 8.13956C14.2427 8.13956 14.8455 7.62388 14.8455 6.85965C14.8455 6.09542 14.2413 5.57974 13.4999 5.57974C12.7571 5.57974 12.1571 6.09542 12.1571 6.85965C12.1571 7.62388 12.7571 8.13956 13.4999 8.13956ZM13.7613 16.1776C13.7613 16.0247 13.8142 15.6276 13.7842 15.4019L12.61 16.7532C12.3671 17.0089 12.0629 17.1861 11.92 17.1389C11.8552 17.1151 11.801 17.0689 11.7672 17.0086C11.7335 16.9484 11.7223 16.8781 11.7357 16.8104L13.6927 10.628C13.8527 9.8437 13.4128 9.12806 12.48 9.03664C11.4958 9.03664 10.0473 10.0351 9.16592 11.3022C9.16592 11.4536 9.13735 11.8307 9.16735 12.0564L10.3401 10.7037C10.583 10.4508 10.8658 10.2723 11.0086 10.3208C11.079 10.3461 11.1367 10.3979 11.1693 10.4652C11.2019 10.5325 11.2068 10.6099 11.1829 10.6808L9.24305 16.8332C9.01878 17.5532 9.44304 18.2588 10.4715 18.4188C11.9857 18.4188 12.8799 17.4446 13.7627 16.1776H13.7613Z"
        fill="white"
        fillOpacity="0.64"
      />
    </svg>
  );

  return (
    <div
      className={styles.infoButtonContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={styles.infoButton}
        aria-label="Information"
        type="button"
      >
        {icon || defaultIcon}
      </button>

      {/* Всплывающая подсказка при наведении */}
      {isTooltipVisible && <div className={styles.tooltip}>{tooltip}</div>}
    </div>
  );
};
